<template>
	<form @submit.prevent="onSubmit" class="shadow-lg p-5">

	<div class="mb-5">
		<label class="block font-semibold mb-2">Name</label>
		<input class="w-full outline-none text-sm border border-gray-primary text-gray-secondary py-2 px-4 pr-8 rounded"
			type="text"
			v-model.trim="role.name"
			required>
	</div>

	<div class="mb-5">
		<label class="block font-semibold mb-2">Permissions</label>
		<v-select v-model="role.permissions" :options="permissions" :reduce="permissions => permissions.name" label="name" class="style-selector" multiple>
		</v-select>
	</div>

	<button class="mt-3 sm:mt-0 inline-block bg-gold-primary focus:outline-none hover:opacity-75 duration-200 ease-in-out text-sm text-white px-6 py-2 rounded-full" type="submit">
		{{ defaultRole ? 'Update' : 'Create' }}
	</button>

	</form>
</template>


<script>
import RoleServices from '@vue/Services/RoleServices';

export default {
	props: {
		permissions: { required: true, type: Array },
		defaultRole: { required: false, type: Object }
	},
	data() {
		return {
			role: {
				permissions: [],
			}
		}
	},
	created() {
		if (this.defaultRole) this.role = this.defaultRole;
	},
	methods: {
		onSubmit() {

			if(this.role.permissions.length == 0){
				alert("The permissions field is required");
				return;
			}

			if(this.role.permissions[0].name){

				let arrPermissions = [];

				this.role.permissions.forEach(element => {
					arrPermissions.push(element.name);
				});

				this.role.permissions = arrPermissions;
			}
			
			RoleServices.save(this.role, (data) => {
				location.href = data.data;
			}, (error) => {

				let errMessage = error.data.errors;
				// console.log(errMessage);
				alert(errMessage[Object.keys(errMessage)[0]]);
			});
		}
	}
}
</script>

<style >
	.v-select.style-selector .vs__dropdown-toggle .vs__selected-options .vs__selected{
		background-color: #b1865b !important;
		color: white !important;
		padding: 5px 8px;
		margin: 5px;
		border: 0;
	}

	.v-select.style-selector .vs__dropdown-toggle .vs__selected-options .vs__selected .vs__deselect{
		fill: white !important;
		padding: 5px;
	}
</style>
